<template>
    <div>
        <button type="button" class="btn btn-info btn-block" @click="refresh" :disabled="loading">
            <icon-arrow-repeat v-if="!loading"/>
            <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{translate('synchronize')}}
        </button>
        <signature-modal
            v-if="isSignaturePanelVisible"
            :signingItems="signingItems"
            :identityNumber="identityNumber"
            :processingMessage="processingMessage"
            @close="isSignaturePanelVisible=false"
            @completed="signingCompleted"
            ></signature-modal>
    </div>

</template>
<script>
import axios from 'axios'
import signatureModal from '../components/SignatureModal.vue'

import iconArrowRepeat from '../components/Icons/arrow-repeat.svg'
export default {
    components: {
        iconArrowRepeat,
        signatureModal
    },
    data(){
        return {
            loading: false,
            isSignaturePanelVisible: false,
            signingItems: [],
            processingMessage: '',
            identityNumber: this.$root.$data.login.User.IdentityNumber
        }
    },
    props: {
        providerId: {
            type: String,
            required: true
        },
        folder: {
            type: String,
            default: 'Inbox'
        }
    },
    methods: {
        signingCompleted(){
            this.processingMessage = this.translate('processingMessages.remSynchronizing');
            this.refresh();
        },
        refresh(){
            this.loading = true;
            return axios.post('/rembox/refresh', {
                ProviderId: this.providerId,
                Folder: this.folder
            })
            .then(x => {
                console.log(x);
                this.loading = false;
                this.isSignaturePanelVisible = false;
                this.$emit('completed');
            })
            .catch(x => {
                if(x.response.data.Message !== ""){
                    alert(x.response.data.Message)
                    this.loading = false;
                } else if(x.response.data.ModelState.RemSessionTimeoutException) {
                    alert(x.response.data.ModelState.RemSessionTimeoutException);

                    if(this.hasAuth('Rem') && this.hasModule('REM')) {
                        this.signingItems = [
                            {
                                DocumentId: "agreement",
                                SignatureFormat: "CAdES",
                                FileName : "KEP oturum taahhütnamesi.txt",
                                State: '',
                                GetUrl: `/RemBox/login?providerId=${this.providerId}`,
                                PostUrl: '/RemBox/login',
                                PostParams: { ProviderId: this.providerId, JobId: "keplogin", DocumentId: "kepdocument" }
                            }
                        ];

                        this.isSignaturePanelVisible = true;
                    }
                }else {
                    this.processingMessage = null;
                    this.isSignaturePanelVisible = false;
                    window.processErrorResponse(x, this);
                }
                this.loading = false;
            });
        }
    }
}
</script>